import React from 'react'
import './about.css'
import Me from '../../images/showcase.svg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
    return (
        <section id='about'>
            <h5>Get To Know</h5>
            <h2>About Me</h2>

            <div className="container about__container">
                <div className="about__me">
                    <div className="about__me-image">
                        <img src={Me} alt="" />
                    </div>
                </div>

                <div className="about__content">
                    <div className="about__cards">
                        <article className='about__card'>
                            <FaAward className='about__icon'/>
                            <h5>B.Tech '24</h5>
                            <small>NIT Patna | CGPA - 7.92</small>
                        </article>
                        <article className='about__card'>
                            <FiUsers className='about__icon'/>
                            <h5>Intermediate</h5>
                            <small>86.2%</small>
                        </article>
                        <article className='about__card'>
                            <VscFolderLibrary className='about__icon'/>
                            <h5>Matriculation</h5>
                            <small>10 CGPA </small>
                        </article>
                    </div>
                   
                    <p>
                        Backend Developer with experience in Java, Spring Boot, Microservices, and Kafka in the Payments domain. Strong problem-solving skills with 1200+ DSA problems solved across <a href="https://leetcode.com/daredreamer/" target='_blank' rel="noreferrer noopener">LeetCode</a> & <a href="https://auth.geeksforgeeks.org/user/deepak15040/" target='_blank' rel="noreferrer noopener">GeeksforGeeks</a>. Hands-on experience in building scalable backend systems, REST APIs, and cloud-based solutions (AWS). Interested in AI systems, distributed systems, and high-scale backend engineering.
                    </p>

                    <a href="#contact" className='btn btn-primary'>Let's Talk</a>

                </div>

            </div>

        </section>
    )
}

export default About
